import { useEffect } from 'react';

// Ref-counted body scroll lock. Multiple overlays (mobile nav drawer, ChangesPanel
// bottom-sheet, future modals) can request a lock simultaneously; the page stays
// locked until the last one releases, and the original overflow is restored only
// then. A naive per-component save/restore would clobber when two overlays overlap
// (closing one would unlock while the other is still open).
let lockCount = 0;
let prevOverflow = '';

export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    if (lockCount === 0) {
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    lockCount += 1;
    return () => {
      lockCount -= 1;
      if (lockCount === 0) {
        document.body.style.overflow = prevOverflow;
      }
    };
  }, [active]);
}
